export const escapeCsvValue = (value: string): string => {
  const stringValue = value ?? '';

  if (/[",\n\r]/.test(stringValue)) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }

  return stringValue;
};

export const convertToCsv = (headers: string[], rows: string[][]): string => {
  const headerLine = headers.map(escapeCsvValue).join(',');
  const dataLines = rows.map(row => row.map(escapeCsvValue).join(','));

  return [headerLine, ...dataLines].join('\r\n');
};

export const downloadBlob = (blob: Blob, filename: string): void => {
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = objectUrl;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(objectUrl);
};

export const getFilenameFromContentDisposition = (
  contentDisposition: string | undefined,
  fallback: string,
): string => {
  if (!contentDisposition) {
    return fallback;
  }

  const utf8Match = /filename\*=UTF-8''([^;]+)/i.exec(contentDisposition);
  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1].trim());
  }

  const asciiMatch = /filename="?([^";]+)"?/i.exec(contentDisposition);
  if (asciiMatch?.[1]) {
    return asciiMatch[1].trim();
  }

  return fallback;
};

export const downloadCsv = (content: string, filename: string): void => {
  const blob = new Blob(['\uFEFF', content], { type: 'text/csv;charset=utf-8;' });
  downloadBlob(blob, filename.endsWith('.csv') ? filename : `${filename}.csv`);
};
